import {
  TextInput as AdminTextInput,
  CreateButton,
  DatagridConfigurable,
  DeleteWithConfirmButton,
  EditButton,
  ExportButton,
  FilterButton,
  FilterForm,
  List as RAList,
  SelectColumnsButton,
  TextField,
  TopToolbar,
} from "react-admin";
import { Box, Card } from "@mui/material";

import CustomPagination from "../../CustomPagination";
import { GlobalListStyles } from "src/libs/globalListStyles";
import i18next from "src/locales";

export const LocationsFilter = [
  <AdminTextInput key="company" source="name" alwaysOn />,
  <AdminTextInput key="street" source="street" alwaysOn />,
  <AdminTextInput key="town" source="town" alwaysOn />,
  <AdminTextInput key="zip" source="zip" alwaysOn />,
  <AdminTextInput key="country" source="country" alwaysOn />,
];

const Actions: React.FC = () => (
  <Box width="100%">
    <TopToolbar style={{gap: 45}}>
      <FilterForm filters={LocationsFilter} />
      <FilterButton filters={LocationsFilter} />
      <SelectColumnsButton />
      <CreateButton />
      <ExportButton label={i18next.translate('resources.Global.exportCSV')} />
    </TopToolbar>
  </Box>
);

export const LocationsList = () => {
  return (
    <RAList actions={<Actions />} pagination={<CustomPagination />} sx={{
      width: "calc(100vw - 50px)",
    }}>
      <GlobalListStyles />
      <Card sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 180px)",
        overflow: "hidden",
        width: "calc(100vw - 50px)",
      }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DatagridConfigurable
            size="small"
            sx={{
              "& tr td": { paddingTop: 1, paddingBottom: 1 },
              "& .RaDatagrid-rowOdd": { backgroundColor: "#f0f0f0" },
            }}
          >
            <TextField source="name" />
            <TextField source="customerNumber" />
            <TextField source="street" />
            <TextField source="houseNumber" />
            <TextField source="town" />
            <TextField source="zip" />
            <TextField source="country" />
            <TextField source="profitCenter" />
            <EditButton />
            <DeleteWithConfirmButton mutationMode="pessimistic" />
          </DatagridConfigurable>
        </Box>
      </Card>
    </RAList>
  );
};
